import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { ExperiencePrimaryImage } from '@/features/layouts/components/PrimaryImage';
import type { BannerProps } from '.';

export const BannerRead = ({ height, borderRadius }: BannerProps) => {
  const { experience } = usePageExperienceContext();

  return (
    <ExperiencePrimaryImage
      borderRadius={borderRadius}
      experience={experience}
      height={height}
      maxHeight={200}
    />
  );
};
